import { useMemo } from "react"

import type { ChatAppResponse, ChatSessionParticipant } from "@/api/models"
import type { SharedHistoryMarkerMap } from "@/features/chat/utils/shared-history"

import { buildSharedHistoryMarkers } from "@/features/chat/utils/shared-history"
import { getResponseContext } from "@/utils/response-format-utils"

type ChatAnswer = [string, ChatAppResponse]

export const useSharedHistoryMarkers = (
  answers: ChatAnswer[],
  participants: ChatSessionParticipant[] | undefined,
  currentUserParticipant?: ChatSessionParticipant
): {
  messageIdsForSharing: string[]
  sharedHistoryMarkers: SharedHistoryMarkerMap
} => {
  const messageIdsForSharing = useMemo(
    () =>
      answers
        .map((answer) => answer[1].messageId || getResponseContext(answer[1]).message_id)
        .filter((messageId): messageId is string => Boolean(messageId)),
    [answers]
  )

  const sharedHistoryMarkers = useMemo(
    () => buildSharedHistoryMarkers(participants, messageIdsForSharing, currentUserParticipant),
    [participants, messageIdsForSharing, currentUserParticipant]
  )

  return { messageIdsForSharing, sharedHistoryMarkers }
}
